import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'

export interface UserStory {
  id: string
  short_id: string
  feature_id: string
  title: string
  as_a?: string
  i_want?: string
  so_that?: string
  business_rules?: string
  acceptance_criteria?: string
  status: 'pending_validation' | 'validated' | 'to_do' | 'in_progress' | 'testing' | 'done'
  order_index: number
  created_at: string
  updated_at: string
}

async function fetchUserStories(featureId: string): Promise<UserStory[]> {
  const { data, error } = await supabase
    .from('user_stories')
    .select('*')
    .eq('feature_id', featureId)
    .order('order_index', { ascending: true })

  if (error) {
    throw new Error(error.message)
  }

  return (data || []) as UserStory[]
}

export function useUserStories(featureId: string | undefined) {
  return useQuery({
    queryKey: ['userStories', featureId],
    queryFn: () => fetchUserStories(featureId!),
    enabled: !!featureId,
  })
}
